import { render, staticRenderFns } from "./ScholarUpdateDetailsDialog.vue?vue&type=template&id=353a5baf&lang=pug&"
import script from "./ScholarUpdateDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./ScholarUpdateDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports